import { render, staticRenderFns } from "./keyword-strategy-tpl-use.vue?vue&type=template&id=a9a5f152&scoped=true&"
import script from "./keyword-strategy-tpl-use.vue?vue&type=script&lang=js&"
export * from "./keyword-strategy-tpl-use.vue?vue&type=script&lang=js&"
import style0 from "./keyword-strategy-tpl-use.vue?vue&type=style&index=0&id=a9a5f152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a5f152",
  null
  
)

export default component.exports